import React from 'react';

const ResultsHeader = ({ resultCount, savedCount }) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <div className="text-lg font-medium text-[#e4e6eb]">
        {resultCount} alumni found • {savedCount} saved
      </div>
    </div>
  );
};

export { ResultsHeader };
